import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { FiEdit, FiTrash2, FiPlus, FiSearch } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { useAuth } from '../contexts/AuthContext';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';

const NiveauQualifProfPage = () => {
  // eslint-disable-next-line no-unused-vars
  const { user } = useAuth();
  const [niveaux, setNiveaux] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ niveau: '' });
  const [searchTerm, setSearchTerm] = useState('');
  const [filtered, setFiltered] = useState([]);

  const fetchNiveaux = async () => {
    const res = await api.get('/niveau-qualif-prof');
    setNiveaux(res.data.data || []);
  };

  useEffect(() => { fetchNiveaux(); }, []);

  useEffect(() => {
    setFiltered(
      niveaux.filter(n => (n.niveau || '').toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }, [searchTerm, niveaux]);

  const handleEdit = (niveau) => {
    setEditing(niveau);
    setForm({ niveau: niveau.niveau || '' });
    setModalOpen(true);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Supprimer ce niveau ?',
      text: 'Cette action est irréversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Oui, supprimer',
      cancelButtonText: 'Annuler',
    });
    if (result.isConfirmed) {
      await api.delete(`/niveau-qualif-prof/${id}`);
      fetchNiveaux();
      Swal.fire('Supprimé !', 'Le niveau a été supprimé.', 'success');
    }
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    if (editing) {
      await api.put(`/niveau-qualif-prof/${editing.id}`, form);
    } else {
      await api.post('/niveau-qualif-prof', form);
    }
    setModalOpen(false);
    setEditing(null);
    setForm({ niveau: '' });
    fetchNiveaux();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold">Gestion des niveaux de qualification</h1>
        <ConditionalButton
          entity="niveau_qualif_prof"
          permission="create"
          className="px-3 py-2 bg-primary-600 text-white rounded hover:bg-primary-700 flex items-center"
          onClick={() => { setEditing(null); setForm({ niveau: '' }); setModalOpen(true); }}
          title="Ajouter un niveau"
        >
          <FiPlus />
        </ConditionalButton>
      </div>
      {/* Search Bar */}
      <div className="bg-white p-4 rounded-lg shadow mb-6">
        <div className="relative">
          <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Rechercher un niveau..."
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
      <div className="overflow-x-auto rounded shadow">
        <table className="min-w-full divide-y divide-gray-200 bg-white">
          <thead className="bg-gray-200">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-bold uppercase">Niveau</th>
              <th className="px-4 py-2 text-right text-xs font-bold uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filtered.map((niveau) => (
              <tr key={niveau.id} className="hover:bg-gray-50">
                <td className="px-4 py-2 whitespace-nowrap">{niveau.niveau}</td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <ConditionalActions
                    entity="niveau_qualif_prof"
                    onEdit={() => handleEdit(niveau)}
                    onDelete={() => handleDelete(niveau.id)}
                    editIcon={FiEdit}
                    deleteIcon={FiTrash2}
                    className="flex space-x-2"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
          <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
            <h2 className="text-lg font-semibold mb-4">{editing ? 'Modifier' : 'Ajouter'} un niveau</h2>
            <form onSubmit={handleModalSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium mb-1">Niveau</label>
                <input type="text" value={form.niveau} onChange={e => setForm({ ...form, niveau: e.target.value })} className="w-full border rounded px-3 py-2" required />
              </div>
              <div className="flex justify-end gap-2 mt-6">
                <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">Annuler</button>
                <ConditionalButton
                  entity="niveau_qualif_prof"
                  permission={editing ? "update" : "create"}
                  type="submit"
                  className="px-4 py-2 rounded bg-primary-600 text-white hover:bg-primary-700"
                >
                  Enregistrer
                </ConditionalButton>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default NiveauQualifProfPage;
